import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { VacancyStatus } from '../types/jobVacancy';

interface VacancyStatusChipProps {
    status: VacancyStatus;
}

const statusColors: Record<VacancyStatus, ChipProps['color']> = {
    [VacancyStatus.DRAFT]: 'default',
    [VacancyStatus.OPEN]: 'success',
    [VacancyStatus.PAUSED]: 'warning',
    [VacancyStatus.IN_PROGRESS]: 'info',
    [VacancyStatus.CLOSED]: 'error',
    [VacancyStatus.CANCELLED]: 'error'
};

const statusLabels: Record<VacancyStatus, string> = {
    [VacancyStatus.DRAFT]: 'Rascunho',
    [VacancyStatus.OPEN]: 'Aberta',
    [VacancyStatus.PAUSED]: 'Pausada',
    [VacancyStatus.IN_PROGRESS]: 'Em Andamento',
    [VacancyStatus.CLOSED]: 'Fechada',
    [VacancyStatus.CANCELLED]: 'Cancelada'
};

export const VacancyStatusChip: React.FC<VacancyStatusChipProps> = ({ status }) => {
    return (
        <Chip
            label={statusLabels[status]}
            color={statusColors[status]}
            size="small"
        />
    );
}; 